import * as types from '@/store/modules/bodac/catalogue/produitPresse-mutation-type';
import * as allTypes from '@/store/mutation-type';
import { getAll } from '@/api/produit/produitPresse';
import getLogo from '@/services/general/getLogo';
import {
  ajoutLignesCommandeProduitPresseFromPlanningPresse,
} from '@/services/devisCommandes/ajoutProduit/ajoutProduitPresse';
import { SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE } from '@/configuration/devisConf';

function initialState() {
  return {
    produits: [],
    totalProduits: 0,
    brief: {
      references: [],
      libelles: null,
      agencesId: [],
      auto: '',
    },
    panier: [],
    typeDCF: null,
    useEcranAjout: false,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_PRODUITS](state, produits) {
    state.produits = produits;
  },
  [types.SET_TOTAL_PRODUITS](state, totalProduits) {
    state.totalProduits = totalProduits;
  },
  [types.SET_BRIEF](state, brief) {
    state.brief = brief;
  },
  [types.CLEAR_BRIEF](state) {
    state.brief = initialState().brief;
  },
  [types.CLEAR_PANIER](state) {
    state.panier = initialState().panier;
  },
  [types.ADD_LIGNE_IN_PANIER](state, ligne) {
    state.panier.push(ligne);
  },
  [types.SET_PANIER](state, panier) {
    state.panier = panier;
  },
  [types.SET_TYPE_DCF](state, typeDCF) {
    state.typeDCF = typeDCF;
  },
  [types.DELETE_LIGNE_IN_PANIER](state, deleteObject) {
    const panierWithLigneToDelete = state.panier.filter((ligne) => {
      return ligne.isFromDCF === deleteObject.isFromDCF;
    });
    panierWithLigneToDelete.splice(deleteObject.index, 1);
    const panierWithoutLigneToDelete = state.panier.filter((ligne) => {
      return ligne.isFromDCF === !deleteObject.isFromDCF;
    });
    const panier = panierWithLigneToDelete.concat(panierWithoutLigneToDelete);
    state.panier = panier;
  },
  [types.SET_USE_ECRAN_AJOUT](state, useEcranAjout) {
    state.useEcranAjout = useEcranAjout;
  },
  [types.SET_LOGO](state, item) {
    const produit = state.panier.find((ligne) => {
      return item.produitId === ligne.produitId && ligne.logo === undefined;
    });
    if (produit) produit.logo = item.logo ? item.logo : '';
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadProduits({ commit }, data) {
    const response = (await getAll(data)).data.result;
    commit(types.SET_TOTAL_PRODUITS, response.totalCount);
    commit(types.SET_PRODUITS, response.items);
    return {};
  },
  async addLigneInPanier({ commit, rootState }, data) {
    const ligne = await ajoutLignesCommandeProduitPresseFromPlanningPresse(
      data.produitId, data.liaisonsId, data.encartsId, data.parution,
    );
    // Si la ligne est ajouté a un avoir, la quantite dois etre négative.
    if (rootState.commande.commande?.sousType === SOUS_TYPE_AVOIR
      || rootState.commande.commande?.sousType === SOUS_TYPE_AVOIR_SUR_ACOMPTE
    ) {
      ligne.quantite *= -1;
      if (ligne.totalHt) ligne.totalHt = ligne.prixUnitaire * ligne.quantite;
      if (ligne.lignesCommande && Array.isArray(ligne.lignesCommande)) {
        ligne.lignesCommande.forEach(sousLigne => {
          sousLigne.quantite *= -1;
          if (sousLigne.totalHt) sousLigne.totalHt = sousLigne.prixUnitaire * sousLigne.quantite;
        });
      }
    }
    commit(types.ADD_LIGNE_IN_PANIER, ligne);
  },
  loadLogoPanier({ commit, getters }) {
    getters.panier.filter((produit) => {
      return produit.logo === undefined;
    }).forEach(async (produit) => {
      const logo = {
        produitId: produit.produitId,
        logo: await getLogo(produit.produitId),
      };
      commit(types.SET_LOGO, logo);
    });
  },
};

const getters = {
  produits: state => {
    return state.produits;
  },
  totalProduits: state => {
    return state.totalProduits;
  },
  brief: state => {
    return state.brief;
  },
  panier: state => {
    return state.panier.sort(
      (a, b) => new Date(a.dateDebut).getTime() - new Date(b.dateDebut).getTime(),
    );
  },
  typeDCF: state => {
    return state.typeDCF;
  },
  useEcranAjout: state => {
    return state.useEcranAjout;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
